import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=1413975c&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"
import style0 from "./Portal.vue?vue&type=style&index=0&id=1413975c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413975c",
  null
  
)

export default component.exports